import { FieldPath, FieldValues } from 'react-hook-form';
import ControlTeamSelectAutocomplete, { ControlTeamSelectAutocompleteProps } from '@/components/ControlTeamSelectAutocomplete';
import { getConfigFromStorage } from '@/utils/config';

export default function ControlTeamFormSelect<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>(props: ControlTeamSelectAutocompleteProps<TFieldValues, TName>) {
  if (getConfigFromStorage()?.is_multi_team === false) return null;
  return <ControlTeamSelectAutocomplete {...props} />;
}
